(ns core.db.entity.util
  (:refer-clojure :exclude [descendants])
  (:require [core.db.entity.tree :as entity-tree]
            [core.util.util :as util]
            [potpuri.core :as p])
  #?(:clj (:require [core.permission.core :as perm])))

(defn is-type? [type e]
  (-> e :entity/type (= type)))

(defn is-type-fn [& types]
  (comp (set types) :entity/type))

(defn has-some-type? [e]
  (-> e :entity/type some?))

(defn assure-entity-type
  "Accepts an entity and expected entity-type, if the entity type matches
  the expected, returns the entity. Otherwise returns nil."
  [entity expected-entity-type]
  (when (is-type? expected-entity-type entity)
    entity))


(letfn [(descs
          ([entity]
           (some->> entity
                    :entity/_parent
                    (mapcat with-descs)))
          ([entity-type entity]
           (->> (descs entity)
                (filter #(is-type? entity-type %))))
          #?(:clj
             ([entity-type entity user]
              (let [readable? (perm/readable-by-fn user)]
                (->> (descs entity)
                     (filter #(and (is-type? entity-type %)
                                   (readable? %))))))
             :cljs
             ([entity-type entity _]
              ;; In frontend, there should be no entities not readable by the current user.
              ;; Do NOTE however, that this cannot be used to check if someone *else*
              ;; has read rights to the entity.
              (descs entity-type entity))))

        (with-descs
          ([entity] (cons entity (descs entity)))
          ([entity-type entity] (cons entity (descs entity-type entity))))]
  (def ^{:arglists '([entity] [entity-type entity] [entity-type entity user])} descendants
    "Given an entity, returns a lazy sequence of the descendants of an entity. If the
    entity is `nil` returns an empty list. The order of descendants is from given entity
    towards the root entity.

    If the optional `user` parameter is supplied, only returns entities readable by
    that user. Readability checks are skipped on the frontend."
    descs)

  (def ^{:arglists '([entity] [entity-type entity])} with-descendants
    "A seq of `entity` and its [[descendants]]. (`entity` is always included regardless of its type.)

    Prefer `core.db.child-entity` helpers for getting a single level of descendants."
    with-descs))


(def ^{:arglists '([entity])} with-ancestors
  "Given an entity, returns a lazy sequence of entity and its ancestors. The first element
  of the returned sequence is always the provided entity. If the entity is `nil` returns `nil`.
  The order of ancestors is from given entity towards the root entity."
  entity-tree/lazy-ancestors)

(defn child
  "Return the first child found matching the type"
  [entity type]
  (p/find-first (:entity/_parent entity) (is-type-fn type)))

(defn ->map
  "Shallow convert an entity to a map"
  [entity]
  (into {:db/id (:db/id entity)}
        entity))

(defn latest
  "Get latest created among entities"
  [entities]
  (reduce #(util/max-comparable-key :entity/created %1 %2)
          nil entities))

(defn earliest
  "Get earliest created among entities"
  [entities]
  (->> entities
       (sort-by :entity/created)
       first))
